import React, { useState } from 'react';
import { Header } from '../components/Header';
import { Button, Form, Row } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { Footer } from '../components/Footer';
import Modal from 'react-bootstrap/Modal';

import {Trans, useTranslation } from 'react-i18next';

const RegisterForm = () => {
    const { t } = useTranslation();
    const navigate = useNavigate(); 

    const [username, setUsername] = useState('');
    const [fullname, setFullname] = useState('');
    const [email, setEmail] = useState('');

    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [showRegisteredModal, setShowRegisteredModal] = useState(false);
    const closeToLogin = () => {
        setShowRegisteredModal(false);
        navigate('/SignIn', { replace: true });
    }

    const handleRegister = async (e) => {
        e.preventDefault();
        try {
            const response = await fetch('https://booking.bernard.vn/api/auth/register', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ PhoneNumber: username, FullName: fullname, Email: email }),
            });

            if (response.ok) {                
                var r = await response.json();                      
                navigate('/changePassword', { state: { token: r.token, person_code: r.person_code }, replace: true });
            } else {     
                var res = await response.json();
                var message = res.message;
                if(message === "REGISTERED")
                {
                    setShowRegisteredModal(true);
                }
                else{
                    handleShow();
                }
            }
        } catch (error) {
            console.log('Timeout');
        }
    };

    return (
        <div className='page-fullscreen'>
            <Modal centered show={show} onHide={handleClose} animation={false}>
                <Modal.Header closeButton>
                    <Modal.Title>{t('register_fail')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Trans i18nKey="register_fail_message">
                        <Link to="tel:+842835352468"></Link>
                        <Link to="tel:+84911072200"></Link>
                    </Trans>                    
                 </Modal.Body>   
                <Modal.Footer>
                    <Button variant="primary" onClick={handleClose}>
                        {t('close')}
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal centered show={showRegisteredModal} onHide={closeToLogin} animation={false}>
                <Modal.Header closeButton>
                    <Modal.Title>{t('register_exist')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Trans i18nKey="register_exist_message">
                        <Link to="/signin"></Link>                        
                    </Trans>
                 </Modal.Body>   
                <Modal.Footer>
                    <Button variant="primary" onClick={closeToLogin}>
                        {t('close')}
                    </Button>
                </Modal.Footer>
            </Modal>

            <Header />
            <div className='page-content'>
                <Row style={{ height: 100 + '%', margin: 0 }}>
                    <div className='col-lg-6 col-xs-12 blue-bg'>
                        <div className='left-panel'>
                            <div className='login-form vertical-center'>
                                <div className='form-heading'>
                                    <div className='title'>
                                        {t('account_register')}
                                    </div>
                                    <div className='sub-title'>
                                        {t('enter_login_info')}
                                    </div>
                                </div>
                                <Form onSubmit={handleRegister}>
                                    <Form.Group className="mt-3">
                                        <Form.Control name='username' required type="text" placeholder={t('phone_number')} value={username} onChange={(e) => setUsername(e.target.value)} />
                                        <Form.Control name='fullname' type="text" placeholder={t('full_name')} value={fullname} onChange={(e) => setFullname(e.target.value)} />
                                        <Form.Control name='email' type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} />
                                    </Form.Group>
                                    <Form.Group className="mt-3" style={{ display: 'flex', flexDirection: 'row' }}>
                                        <Button type='submit' className='submit' style={{ width: 100 + '%' }}>{t('register')}</Button>
                                    </Form.Group>
                                    <Form.Group className='mt-3' style={{ display: 'flex', flexDirection: 'row', justifyContent: 'right' }}>
                                        <Link to={'/signin'}>{t('have_account')}</Link>
                                    </Form.Group>
                                </Form>
                            </div>
                        </div>
                    </div>
                    <div className='right-panel col-lg-6 col-xs-12' style={{ backgroundImage: "url(/images/bg-1.png)", backgroundSize: 'cover' }}>
                    </div>
                </Row>
            </div>
            <Footer />
        </div >
    )
}
export default RegisterForm;
